export default class Key {
    constructor(key) {
        this.key = key;
        this.isDown = false;
        this.isUp = true;
        this.press = undefined;
        this.release = undefined;
        this.downHandler = this.keyDown;
        this.upHandler = this.keyUp;
        window.addEventListener('keydown', this.downHandler.bind(this));
        window.addEventListener('keyup', this.upHandler.bind(this));
    }
    destroy() {
        window.removeEventListener('keydown', this.downHandler.bind(this));
        window.removeEventListener('keyup', this.upHandler.bind(this));
    }
    keyDown(event) {
        if (event.key === this.key) {
            if (this.isUp && this.press) {
                this.press();
            }
            this.isDown = true;
            this.isUp = false;
            event.preventDefault();
        }
    }
    keyUp(event) {
        if (event.key === this.key) {
            if (this.isDown && this.release) {
                this.release();
            }
            this.isDown = false;
            this.isUp = true;
            event.preventDefault();
        }
    }
}
